import PublicRoutes from './component'

export default PublicRoutes
